import { Stack } from '@mui/material';

import clsx from 'clsx';

import { FormValues } from '../types';
import { ClassCard, classListClasses, RadioOption } from './styles';
import useClassList, { UseClassList } from './vm';
import { AttendanceDataItem } from '../../../../../../../../../db/classes/types';
import RadioGroup from '../../../../../../../../../components/HookFormControls/RadioGroup';
import Skeleton from './skeleton';

export interface ClassListProps<T extends FormValues> extends UseClassList<T> {
  isLoading: boolean;
  /** @default false */
  disabledOption?: boolean;
  classList: AttendanceDataItem['classData'];
  className?: string;
}

const ClassList = <T extends FormValues>({
  isLoading,
  classList,
  className,
  disabledOption = false,
  ...vmProps
}: ClassListProps<T>) => {
  const { control, name } = vmProps;
  const { selectedClassId } = useClassList(vmProps);

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <RadioGroup control={control} name={name} fullWidth className={className}>
      <Stack gap={1.5} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {classList.map((cls) => (
          <RadioOption key={cls.classId} value={cls.classId} disabled={disabledOption}>
            <ClassCard
              classId={cls.classId}
              endTime={cls.endTime}
              isIncharge={cls.isIncharge}
              markedInStudents={cls.numPresent}
              startTime={cls.startTime}
              type="attendance"
              className={clsx(classListClasses.classCard, {
                [classListClasses.selectedClass]: cls.classId === selectedClassId,
              })}
            />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default ClassList;
